const fetchGroupSetsReducer = (state, action) => {
  switch (action.status) {
    case 'started':
      return {
        ...state,
        error: undefined,
        groupSetsLoaded: false,
      };
    case 'success':
      return {
        ...state,
        error: undefined,
        groupSetsLoaded: true,
      };
    case 'error':
      return {
        ...state,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export default fetchGroupSetsReducer;
